import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { PilotControlledLighting } from '../models/pilot-controlled-lighting.model';


@Injectable()
export class PilotControlledLightingService {

  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) { }

  /**
   * updates specified entity via api
   * @param {number} airportID
   * @param {PilotControlledLighting} pcl
   * @return {Promise<any>}
   */
  putPCL(airportID: number, pcl: PilotControlledLighting): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/pcl/${pcl.pclId}`;
    try {
      const BODY = this._getFuelJSON(pcl);
      return this._http.put(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * adds specified entity via api
   * @param {number} airportID
   * @param {PilotControlledLighting} pcl
   * @return {Promise<any>}
   */
  postPCL(airportID: number, pcl: PilotControlledLighting): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/pcl/`;
    try {
      const BODY = this._getFuelJSON(pcl);
      return this._http.post(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * deletes specified entity via api
   * @param {number} airportID
   * @param {number} pclID
   * @return {Promise<any>}
   */
  deletePCL(airportID: number, pclID: number): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/pcl/${pclID}`;
    try {
      return this._http.delete(URL).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * converts entity to json obj
   * @param {PilotControlledLighting} pcl
   * @return {any}
   * @private
   */
  _getFuelJSON (pcl: PilotControlledLighting): any {
    return {
      intensity: PilotControlledLighting.formatLightingIntensity(pcl.intensity).toLowerCase(),
      clicks: pcl.clicks,
      seconds: pcl.seconds
    };
  }
}
